import React from 'react';
import {useServices} from '../../react-hooks/use-services.hook';
import {BonusAndCashBalance} from "./bonus-and-cash-balance/bonus-and-cash-balance.component";
import {UserBalanceButtons} from "./balance-box-buttons/user-balance-buttons.component";
import {UserMenuBalanceLabelBox} from "./boxes/user-menu-balance-label.box";
import { BalanceValue } from './balance-value.component';
import { BalanceValuePrimaryBox } from './balance-value-boxes/balance-value-primary.box';
import {CyClass} from '../../../common/cy-classes';
import {UserMenuSectionBox} from '../user-menu/user-menu/boxes/section/user-menu-section.box';
import {FlexContainerBox} from '../../themes/architecture/css-helpers/flex';
import {UserMenuSeparatorBox} from '../user-menu/user-menu-items/boxes/separator/user-menu-separator.box';
import {SpacerBox} from '../../basic-ui-components/layout/spacer.box';

export const UserBalance: React.FC = () => {
    const services = useServices();
    return <UserMenuSectionBox className={CyClass("cy-balance-box")}>
        <FlexContainerBox alignItems='center' justifyContent='space-between'>
            <UserMenuBalanceLabelBox>{services.translation.translate('BALANCE')}</UserMenuBalanceLabelBox>
            <BalanceValue className={CyClass('cy-balance-box-amount')} WrapperComponent={BalanceValuePrimaryBox} />
        </FlexContainerBox>
        <UserMenuSeparatorBox />
        <BonusAndCashBalance />
        <FlexContainerBox></FlexContainerBox>
        <UserBalanceButtons />
        <SpacerBox height='1rem' />
    </UserMenuSectionBox>;
};
